// @flow

// http://stackoverflow.com/questions/10073699/pad-a-number-with-leading-zeros-in-javascript#10073788
export default function leftPad(n: string, width: number, z: string) {
  z = z || "0";
  n = n + "";
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}
